<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Members</b>
        <b-button type="button" variant="outline-primary" size="sm" class="float-right" @click="showCreateUserMemberModal = true">
          <span class="button-text">Add Member</span>
        </b-button>
      </b-card-header>

      <!-- List group Members -->

      <div v-if="orgMembers.length">
         <b-list-group v-for="um in orgMembers" :key="um.id" flush>

         <b-list-group-item>
          <a href="#" @click.prevent="showUpdateMemModal(um)">
              {{um.muser.fullName}}
          </a>
          <img v-if="!um.muser.active" src='static/img/Inactive.png' height="21" width="21">
           <img v-if="um.primaryOrganization === organizationId " src="static/img/ManagerYes.png" height="21" width="21">
            <img  src='static/img/Primary.png' v-if="isPrimaryOrg(um.muser.primaryOrganization)" height="21" width="21">
            <img :src="'static/img/' + (um.isOrgAdmin ? 'AdminYes.png' : 'AdminNo.png')" height="21" width="21">
            <img :src="'static/img/' + (um.isManager ? 'ManagerYes.png' : 'ManagerNo.png')" height="21" width="21">
            <img v-if="um.isDWUser" :src="'static/img/' + ('DWUserYes.png')" height="21" width="21">
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-else>
        <b-list-group flush>
          <b-list-group-item>
            <p>
              This Organization does not have any Members.
            </p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <CreateOrganizationsMemberModal
    :showModal.sync="showCreateUserMemberModal"
    :existingUser = "existingMembership"
    :orgId = "organizationId"
    >
    </CreateOrganizationsMemberModal>

    <UpdateOrganizationsMemberModal
    :showModal.sync="showUpdateUserMemberModel"
    :selectedMemRec = "selectedMemRec"
    :organizationName = "organizationName"
    :disableDelete = "canDelteMem"
    >
    </UpdateOrganizationsMemberModal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CreateOrganizationsMemberModal from '@/components/Admin/CreateOrganizationsMemberModal'
import UpdateOrganizationsMemberModal from '@/components/Admin/UpdateOrganizationsMemberModal'
export default {
  name: 'OrganizationMembers',
  props: {
    organizationId: Number,
    organizationName: String
  },
  data: function () {
    return {
      showCreateUserMemberModal: false,
      showUpdateUserMemberModel: false,
      selectedMemRec: null,
      canDelteMem: false
    }
  },
  components: {
    CreateOrganizationsMemberModal,
    UpdateOrganizationsMemberModal
  },
  computed: {
    ...mapGetters({
      organizationMemberships: 'getOrgMembers'
    }),
    orgMembers () {
      const members = this.organizationMemberships
      console.log('userMemberships', members)
      return members && members.length
        ? _.sortBy(members, 'muser.fullName')
            .filter((item) => item.muser && !item.muser.isRemoved)
        : []
    },
    existingMembership: function () {
      return this.orgMembers
        .map((item) => {
          return item && item.muser
            ? item.muser.id
            : item
        })
    }
  },
  async created () {
    if (this.organizationId) {
      await this.$store.dispatch('getOrgUserMemberships', {
        morganization: this.organizationId,
        populate: 'muser'
      })
    }
  },
  methods: {
    isPrimaryOrg (primaryOrganizationId) {
      return primaryOrganizationId === this.organizationId
    },
    showUpdateMemModal (memRec) {
      this.canDelteMem = this.isPrimaryOrg(memRec.muser.primaryOrganization)
      this.selectedMemRec = memRec
      this.showUpdateUserMemberModel = true
    }
  },
  beforeDestroy () {
    this.$store.commit('resetOrgMembers')
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Admin/OrganizationMembers.vue